/* ============================================================
   COVRPACK — Page panier groupée par fournisseur (v1.0)
   Fichier : assets/covrpack-cart.js
   - Quantités, suppression, ajout suggéré : API AJAX du panier puis
     re-rendu de la section (Section Rendering API).
   - Dates de livraison, compte à rebours avant l'heure limite et frise
     des colis : heure de Paris, jours ouvrés (fériés FR ou UE).
   - Le bloc Webkul est déplacé tel quel d'un rendu à l'autre.
   ============================================================ */
(function () {
  'use strict';

  var DAY = 86400000;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ── Dates ─────────────────────────────────────────────── */

  function parisNow() {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month - 1, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
  }

  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }

  var holidayCache = {};
  function holidays(y, zone) {
    var key = zone + y;
    if (holidayCache[key]) return holidayCache[key];
    var e = easter(y);
    var list = zone === 'eu'
      // Europe : jours fériés communs aux 5 pays desservis (le délai reste indicatif*)
      ? [Date.UTC(y, 0, 1), Date.UTC(y, 4, 1), Date.UTC(y, 11, 25)]
      : [Date.UTC(y, 0, 1), e + DAY, Date.UTC(y, 4, 1), Date.UTC(y, 4, 8), e + 39 * DAY, e + 50 * DAY,
         Date.UTC(y, 6, 14), Date.UTC(y, 7, 15), Date.UTC(y, 10, 1), Date.UTC(y, 10, 11), Date.UTC(y, 11, 25)];
    return (holidayCache[key] = list);
  }

  function isBiz(t, zone) {
    var wd = new Date(t).getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return holidays(new Date(t).getUTCFullYear(), zone).indexOf(t) === -1;
  }

  function addBiz(t, n, zone) {
    while (n > 0) { t += DAY; if (isBiz(t, zone)) n--; }
    return t;
  }

  // Jour d'expédition : aujourd'hui si avant l'heure limite (ou sans heure limite) un jour ouvré
  function shipDay(now, cutoff, zone) {
    var today = Date.UTC(now.y, now.m, now.d);
    if (isBiz(today, zone) && (cutoff == null || now.h < cutoff)) return today;
    return addBiz(today, 1, zone);
  }

  /* ── Formatage ─────────────────────────────────────────── */

  function fill(str, o) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; });
  }

  function fmtDate(t, lang, opts) {
    if (/^en/i.test(lang)) lang = 'en-GB'; // « Tuesday 6 October »
    var fr = /^fr/i.test(lang), f;
    try { f = new Intl.DateTimeFormat(lang, Object.assign({ timeZone: 'UTC' }, opts)); }
    catch (e) { f = new Intl.DateTimeFormat('fr', Object.assign({ timeZone: 'UTC' }, opts)); fr = true; }
    return f.formatToParts(new Date(t)).map(function (p) {
      return (fr && p.type === 'day' && p.value === '1') ? '1er' : p.value;
    }).join('');
  }
  function longDate(t, lang) { return fmtDate(t, lang, { weekday: 'long', day: 'numeric', month: 'long' }); }
  function shortDate(t, lang) { return fmtDate(t, lang, { weekday: 'short', day: 'numeric', month: 'short' }); }
  function weekday(t, lang) { return fmtDate(t, lang, { weekday: 'long' }); }
  function dayDate(t, lang, withMonth) { return fmtDate(t, lang, withMonth ? { weekday: 'long', day: 'numeric', month: 'long' } : { weekday: 'long', day: 'numeric' }); }

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }

  /* ── Rendu des délais ──────────────────────────────────── */

  function renderEta(root) {
    var cfgEl = root.querySelector('[data-cvr-cart-i18n]');
    if (!cfgEl || !window.Intl) return;
    var T;
    try { T = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var lang = T.lang || document.documentElement.lang || 'fr';
    var zone = root.getAttribute('data-zone') || 'fr';
    var now = parisNow();
    var today = Date.UTC(now.y, now.m, now.d);
    var rows = [];

    root.querySelectorAll('[data-parcel]').forEach(function (parcel) {
      var label = parcel.getAttribute('data-label');
      if (parcel.getAttribute('data-on-request') === 'true') {
        rows.push({ label: label, req: true });
        return;
      }
      var min = num(parcel.getAttribute('data-min')) || 0;
      var max = num(parcel.getAttribute('data-max')) || min;
      var cutoff = num(parcel.getAttribute('data-cutoff'));
      var ship = shipDay(now, cutoff, zone);
      var d1 = addBiz(ship, min, zone), d2 = addBiz(ship, max, zone);
      rows.push({ label: label, d1: d1, d2: d2, fast: parcel.getAttribute('data-highlight') === 'true' });

      // Même formulation que la fiche produit : « Commandez avant lundi 13h et recevez ce produit
      // entre le mardi 6 et le mercredi 7 octobre* », ou compte à rebours le jour même.
      var sameMonth = new Date(d1).getUTCMonth() === new Date(d2).getUTCMonth();
      var range = fill(T.p_range, { from: dayDate(d1, lang, !sameMonth), to: dayDate(d2, lang, true) });
      var html;
      if (cutoff != null) {
        var mins = Math.max(1, Math.ceil((ship + cutoff * 3600000 - Date.UTC(now.y, now.m, now.d, now.h, now.mi, now.s)) / 60000));
        if (mins < 24 * 60) {
          var h = Math.floor(mins / 60), m = mins % 60;
          var time = h ? fill(T.time_hm, { h: h, m: (m < 10 ? '0' : '') + m }) : fill(T.time_min, { m: m });
          html = fill(T.p_countdown_html, { time: time, range: range });
        } else {
          html = fill(T.p_deadline_html, { day: weekday(ship, lang), range: range });
        }
      } else {
        html = (parcel.getAttribute('data-override') === 'true' ? T.eta_made_to_order + ' ' : '') + fill(T.p_nocutoff_html, { range: range });
      }
      var out = parcel.querySelector('[data-parcel-eta]');
      if (out) out.innerHTML = html + '<span class="cvr-star">*</span>';

      parcel.querySelectorAll('[data-item-eta]').forEach(function (el) {
        var imin = num(el.getAttribute('data-min')), imax = num(el.getAttribute('data-max'));
        if (imin == null) return;
        var iship = shipDay(now, cutoff, zone);
        // Les textes T.* sont déjà échappés par le filtre Liquid « t »
        el.innerHTML = fill(T.item_eta, { min: imin, max: imax, date: longDate(addBiz(iship, imax, zone), lang) }) + '*';
      });
    });

    renderOverview(root, rows, today, lang, T);
  }

  function renderOverview(root, rows, today, lang, T) {
    var box = root.querySelector('[data-overview]');
    var wrap = root.querySelector('[data-overview-rows]');
    if (!box || !wrap || !rows.length) return;
    var known = rows.filter(function (r) { return !r.req; });
    var end = (known.length ? Math.max.apply(null, known.map(function (r) { return r.d2; })) : today + 5 * DAY) + DAY;
    var span = end - today;
    var html = '';
    rows.forEach(function (r) {
      html += '<div class="cvr-overview__row"><span class="cvr-overview__name" title="' + escapeHtml(r.label) + '">' + escapeHtml(r.label) + '</span><span class="cvr-overview__track">';
      if (r.req) {
        html += '<span class="cvr-overview__bar cvr-overview__bar--req" style="left:0">' + T.on_request + '</span>';
      } else {
        var l = (r.d1 - today) / span * 100;
        var w = Math.max(8, (r.d2 + DAY - r.d1) / span * 100);
        var pos = l + w > 70 ? 'right:' + Math.max(0, 100 - l - w) + '%' : 'left:' + l + '%';
        var txt = shortDate(r.d1, lang) + (r.d1 !== r.d2 ? ' → ' + shortDate(r.d2, lang) : '');
        html += '<span class="cvr-overview__bar' + (r.fast ? '' : ' cvr-overview__bar--slow') + '" style="' + pos + ';width:' + w + '%">' + escapeHtml(txt) + '</span>';
      }
      html += '</span></div>';
    });
    html += '<div class="cvr-overview__row cvr-overview__axis"><span></span><span class="cvr-overview__ticks"><span>' + T.today + '</span><span>' + escapeHtml(shortDate(end - DAY, lang)) + '</span></span></div>';
    wrap.innerHTML = html;
    box.hidden = false;
    // Une barre plus large que la place restante (petit écran) est recalée à droite
    wrap.querySelectorAll('.cvr-overview__bar').forEach(function (bar) {
      var track = bar.parentNode;
      if (bar.offsetLeft + bar.offsetWidth > track.clientWidth) {
        bar.style.left = 'auto';
        bar.style.right = '0';
      }
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Panier AJAX ───────────────────────────────────────── */

  var busy = false;
  var timers = {};

  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function refresh(root) {
    var id = root.getAttribute('data-section-id');
    var wrapper = document.getElementById('shopify-section-' + id);
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cvr-cart]');
        if (!fresh || !wrapper) { window.location.reload(); return; }
        // Garder le bloc Webkul déjà initialisé par l'app
        var wk = root.querySelector('#wk_shipping_calculate_div');
        var newRoot = document.importNode(fresh, true);
        var slot = newRoot.querySelector('#wk_shipping_calculate_div');
        if (wk && slot) slot.parentNode.replaceChild(wk, slot);
        root.parentNode.replaceChild(newRoot, root);
        init(newRoot);
      });
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function run(root, request) {
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    var err = root.querySelector('[data-cart-error]');
    if (err) err.hidden = true;
    request
      .then(function () { return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) { updateHeaderCount(cart); return refresh(root); })
      .catch(function (e) {
        root.classList.remove('is-loading');
        if (err) {
          err.textContent = (e && (e.description || e.message)) || err.textContent;
          err.hidden = false;
        }
      })
      .then(function () { busy = false; });
  }

  function changeQty(root, key, qty) {
    run(root, post('cart/change.js', { id: key, quantity: Math.max(0, qty) }));
  }

  function bind(root) {
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = step.parentNode.querySelector('[data-qty-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
        input.value = next;
        var key = input.getAttribute('data-key');
        clearTimeout(timers[key]);
        timers[key] = setTimeout(function () { changeQty(root, key, next); }, 450);
        return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        e.preventDefault();
        changeQty(root, rm.getAttribute('data-key'), 0);
        return;
      }
      var add = e.target.closest('[data-add-variant]');
      if (add) {
        run(root, post('cart/add.js', { items: [{ id: +add.getAttribute('data-add-variant'), quantity: 1 }] }));
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input) {
        var key = input.getAttribute('data-key');
        clearTimeout(timers[key]);
        changeQty(root, key, parseInt(input.value, 10) || 0);
        return;
      }
      var note = e.target.closest('[data-cart-note]');
      if (note) post('cart/update.js', { note: note.value }).catch(function () {});
    });

    var form = root.querySelector('#CovrCartForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        var terms = root.querySelector('[data-terms]');
        var tErr = root.querySelector('[data-terms-error]');
        if (terms && !terms.checked && e.submitter && e.submitter.name === 'checkout') {
          e.preventDefault();
          if (tErr) tErr.hidden = false;
          terms.focus();
        }
      });
    }
  }

  var tick = null;
  function init(root) {
    bind(root);
    renderEta(root);
    clearInterval(tick);
    tick = setInterval(function () {
      var r = document.querySelector('[data-cvr-cart]');
      if (r) renderEta(r);
    }, 30000);
  }

  function start() {
    var root = document.querySelector('[data-cvr-cart]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
